import { create } from 'zustand';
const useLobbyOutput = create(() => ({
    lobbyView: 'none',
}));
const reactiveOutput = {
    useLobbyView: () => {
        return useLobbyOutput((state) => state.lobbyView);
    },
};
export class LobbyServiceOutput {
    static getReactiveOutput() {
        return reactiveOutput;
    }
    setLobbyView(lobbyView) {
        useLobbyOutput.setState({ lobbyView });
    }
    getLobbyView() {
        return useLobbyOutput.getState().lobbyView;
    }
}
